exports = module.exports = require("../../../../lunch-team-client-checkout-msg/node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".settings-reset-password a[target=_blank]{font-size:18px;color:#0e7a4b;text-decoration:none;border-bottom:1px}.settings-reset-password a[target=_blank]:hover{opacity:.7}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../lunch-team-client-checkout-msg/node_modules/css-loader!../lunch-team-client-checkout-msg/node_modules/sass-loader/dist/cjs.js!./src/containers/Settings/Settings.scss
// module id = 779
// module chunks = 7